<div class="gg-cookie-consent-message-container {{ videoStyleClass() }}">
  <h1>{{ 'cookies.cookiesMessage.messageTitle' | cxTranslate }}</h1>
  <p>{{ 'cookies.cookiesMessage.messageDescription' | cxTranslate }}</p>
  @if (logged$ | async; as logged) {
    <cx-generic-link url="my-account/consents"
      ><a class="btn-link"> {{ 'anonymousConsents.dialog.title' | cxTranslate }}</a></cx-generic-link
    >
  } @else {
    <cx-anonymous-consent-open-dialog></cx-anonymous-consent-open-dialog>
  }
</div>
